var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8606 5.57694C14.6342 2.77019 11.8336 0.808716 8.57475 0.808716C4.45397 0.808716 1.06571 3.94516 0.666992 7.96105M12.5484 5.57693H16.0451C16.3084 5.57693 16.5219 5.36345 16.5219 5.10011V1.60342M1.32829 11.9346C2.55461 14.7413 5.35528 16.7028 8.61409 16.7028C12.7349 16.7028 16.1232 13.5663 16.5219 9.55046M4.64051 11.9346H1.14381C0.880473 11.9346 0.666992 12.148 0.666992 12.4114V15.9081",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/inProgressIcon.72e2a9e638b52ff4d28024d02ac40314.svg";
export { ForwardRef as ReactComponent };